import { render, staticRenderFns } from "./CourseCart.vue?vue&type=template&id=01a58449&scoped=true&"
import script from "./CourseCart.vue?vue&type=script&lang=js&"
export * from "./CourseCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a58449",
  null
  
)

export default component.exports